import { useEffect, useState } from "react";
import type { GfxSnapshot } from "@mma/shared";

export interface GfxLive {
  snapshot: GfxSnapshot | null;
  connected: boolean;
  offset: number; // servertid − lokal tid i ms
}

// Lytter på /api/gfx/stream. EventSource genforbinder selv, fx efter et deploy.
export function useGfxStream(): GfxLive {
  const [live, setLive] = useState<GfxLive>({ snapshot: null, connected: false, offset: 0 });
  useEffect(() => {
    const es = new EventSource("/api/gfx/stream");
    es.onmessage = (e) => {
      const snapshot = JSON.parse(e.data) as GfxSnapshot;
      setLive({ snapshot, connected: true, offset: snapshot.serverNow - Date.now() });
    };
    es.onerror = () => setLive((l) => ({ ...l, connected: false }));
    return () => es.close();
  }, []);
  return live;
}

// Servertid der tikker, så ure kan tælle uden at spørge serveren.
export function useServerNow(offset: number, intervalMs = 200): number {
  const [now, setNow] = useState(() => Date.now() + offset);
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now() + offset), intervalMs);
    return () => clearInterval(t);
  }, [offset, intervalMs]);
  return now;
}
